module.exports = __webpack_public_path__ + "static/media/done.107892e5.png";